import { render, staticRenderFns } from "./DrawLabel.vue?vue&type=template&id=19e73984&"
import script from "./DrawLabel.vue?vue&type=script&lang=js&"
export * from "./DrawLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports